namespace TabAurous.Administration {
    export interface DocumentReportsForm {
        DocumentId: Serenity.IntegerEditor;
        ReportName: Serenity.StringEditor;
        ReportKey: Serenity.StringEditor;
        ReportFile: Serenity.StringEditor;
    }

    export class DocumentReportsForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.DocumentReports';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DocumentReportsForm.init)  {
                DocumentReportsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(DocumentReportsForm, [
                    'DocumentId', w0,
                    'ReportName', w1,
                    'ReportKey', w1,
                    'ReportFile', w1
                ]);
            }
        }
    }
}
